import OrderSummary from './../shared/order-summary.vue';
import Search from '../../blocks/input-elements/search-box';
import CartAlertBox from '../shared/cart-alert-box.vue';
export default {
  name: 'EmptyCart',
  props: ['apiCallFailure'],
  components: {
    OrderSummary,
    Search,
    CartAlertBox
  },
  data() {
    return {
      previousPurchasesURL: 'my-account?#/previousPurchases',
      partNumbersURL: 'my-account?#/myPartNumbers',
      favoritesURL: 'my-account?#/favorites'
    };
  },
  created() {
    if (sessionStorage.getItem('itemRemoved') === 'true') {
      sessionStorage.removeItem('itemRemoved');
    }
  },
  methods: {
    getI18nMessage: function (key) {
      return window.Granite.I18n.get(key);
    }
  }
};